<template>
	<div class='w-full rounded-md ml-auto mb-2 py-4 bg-gray-50 shadow-sm'>
		<div class="flex items-center gap-2 justify-center">

			<p class=" text-gray-800 text-sm md:text-base">
				30% off introductory discount
			</p>

			<div class="flex gap-3 justify-between">
				<div class='border-teal-600 border font-semibold inline-block rounded-full px-3 py-1 text-sm text-primary'>
					<i class='fa fa-check'></i> Applied
				</div>
			</div>

		</div>
		<div v-if="discount != null" class="text-primary text-lg font-semibold text-center">
			- {{ discount.value }}
		</div>
	</div>
</template>
<script>
export default {
	props: {
		quote: {
			type: Object,
			default: null,
		}
	},
	computed: {
		discount() {
			if (this.quote == null) {
				return null;
			}

			return this.quote.discounts.find(d => d.name === 'introduction-discount');
		}
	}
}
</script>